import {
  AdditionalIProps,
  AddContractIProps,
  HistoryIProps,
  ResponseContractListIProps,
  UpdateContractIProps,
  UpdateContractParamsIProps,
  UpdateAdditionalIProps,
  ContractItemIProps,
  PrintTemplateIProps,
} from "../model/schema";
import { NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";

const contractServiceMap = {
  getHystory: "/contract/",
  getContractList: "/contract/dealers",
  getContractById: "/contract/",
  addContract: "/contract",
  getAdditionalList: "/contract/dealers/aditional",
  getAdditionalById: "/contract/additional/",
  addAdditional: "/contract/additional",
  updateContract: "/contract/",
  updateAdditional: "/contract/additional/",

  GET_ADDITIONAL_BY_ID_WRApp: "/internal-api/contract/additional/",
  printTemplate: "/contract/print",
};

export class Contract {
  static GET = {
    getHistory: (id: string): NetworkResponse<HistoryIProps[]> =>
      requestREST.get(`${contractServiceMap.getHystory + id}/history`),

    getContractList: (
      params: string
    ): NetworkResponse<ResponseContractListIProps> =>
      requestREST.get(`${contractServiceMap.getContractList}?${params}`),

    getContractById: (id: string): NetworkResponse<ContractItemIProps> =>
      requestREST.get(contractServiceMap.getContractById + id),

    getAdditionalList: (
      params: string
    ): NetworkResponse<ResponseContractListIProps> =>
      requestREST.get(`${contractServiceMap.getAdditionalList}?${params}`),

    getAdditionalById: (id: string): NetworkResponse<AdditionalIProps> =>
      requestREST.get(contractServiceMap.getAdditionalById + id),
  };
  static POST = {
    addContract: (
      data: AddContractIProps
    ): NetworkResponse<AddContractIProps> =>
      requestREST.post(contractServiceMap.addContract, data),
    addAdditional: (
      data: AdditionalIProps
    ): NetworkResponse<AdditionalIProps> =>
      requestREST.post(contractServiceMap.addAdditional, data),
    printTemplate: (
      params: PrintTemplateIProps
    ): NetworkResponse<ArrayBuffer> =>
      requestREST.post(contractServiceMap.printTemplate, params, {
        responseType: "arraybuffer",
      }),
  };

  static PUT = {
    updateContract: ({
      data,
      id,
    }: UpdateContractParamsIProps): NetworkResponse<UpdateContractIProps> =>
      requestREST.put(contractServiceMap.updateContract + id, data),
    updateAdditional: ({
      data,
      id,
    }: UpdateAdditionalIProps): NetworkResponse<AdditionalIProps> =>
      requestREST.put(contractServiceMap.updateAdditional + id, data),
  };
  static DELETE = {};
}
